export default __webpack_public_path__ + "static/media/dis5.c6219d76.png";